import Accordion from "../../containers/Accordion/Accordion"
import EventLink from "./EventLink"
import React from "react";
import ReactDOM from "react-dom";

// import FormContext from '../../Context/form-context'
function getParameterByName (name){
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
class Event extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        items:[],
        currentMonth:null,
        openItem:0,
        closeAll:false
      };
    }
    Months = ["ינואר", "פבראר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"];
    nextMonth=()=>{
        let month= (this.state.currentMonth.month+1)%12;
        let year= month? this.state.currentMonth.year :  this.state.currentMonth.year +1;
        let nextMonth = {month:month,year:year, text: this.Months[month] + ' ' + year};
        let filteredItems=this.props.items.filter((item)=>{
            return (new Date(item.MODNewsPublishDate).getFullYear() == year) && (new Date(item.MODNewsPublishDate).getMonth() == month);
        });
        this.setState({
            items:filteredItems,
            currentMonth: nextMonth,
            openItem:0,
            closeAll:true
        })
    }
    prevMonth=()=>{
        let month= (12 + this.state.currentMonth.month-1)%12;
        let year= this.state.currentMonth.month > 0 ? this.state.currentMonth.year :  this.state.currentMonth.year -1;
        let nextMonth = {month:month,year:year, text: this.Months[month] + ' ' + year};
        
        let filteredItems=this.props.items.filter((item)=>{
            return (new Date(item.MODNewsPublishDate).getFullYear() == year) && (new Date(item.MODNewsPublishDate).getMonth() == month);
        });
        this.setState({
            items:filteredItems,
            currentMonth: nextMonth,
            openItem:0,
            closeAll:true
        })
    }
    
    componentDidUpdate(prevProps,prevState){
        if(prevProps.items.length != this.props.items.length)
        {
            var items= [...this.props.items];

            if(this.props.layout == 'first'){
                var curMonth =null;
                let eventId,month ,year ;
                try{
                    let url= new URL(window.location.href); 
                     eventId = parseInt(url.searchParams.get("itemId"));
                     month = parseInt(url.searchParams.get("month"));
                     year = parseInt(url.searchParams.get("year"));
                }
                catch(e){
                    eventId = getParameterByName('itemId');
                    month = getParameterByName('month');
                    year = getParameterByName('year');
                }
                
               
                
                if(!eventId){
                    var today = new Date();
                    year=today.getFullYear();
                    month=today.getMonth() 
                }
                curMonth = {year:year ,month: month, text: this.Months[month] + ' ' + year}
                //moment(eventDate).locale('he-il').format('LL')
                
                items = items.filter((item)=>{
                    let date=new Date(item.MODNewsPublishDate)
                    return (date.getFullYear() == curMonth.year) && (date.getMonth() == curMonth.month);
                });
                this.setState(
                    {  
                        currentMonth: curMonth,
                        items:items,
                        openItem: eventId | 0
                    }
                )
                
            }
            else if(this.props.layout == 'second'){
                items= items.slice(0,3);
                this.setState(
                    {  
                        items:items
                    }
                )
            }
        }
        if(prevState.closeAll != this.state.closeAll){
            this.setState({closeAll:true})
        }
    }
    render(){
        let events = null;
        let accordion = null;
        if(this.props.layout =='first'){
            accordion= <Accordion items={this.state.items} 
            WpId={this.props.WpId}
            layout={this.props.layout}
            type={this.props.type}
            limit={this.props.limit}
            moreTitle={this.props.moreTitle} 
            openItem={this.state.openItem}
            closeAll={this.state.closeAll}
            handleUserKeypress = {this.props.handleUserKeypress}/>
            
            events = <React.Fragment>
            <div className="monthArea row no-gutters">
                <i className="col-2 fa fas fa-angle-right" onClick={this.prevMonth}></i>
                <div type='text' className='col-8 curMonth' >{this.state.currentMonth ? this.state.currentMonth.text: null}</div>
                <i className="col-2 fa fas fa-angle-left" onClick={this.nextMonth}></i>
            </div>
           {accordion}
        </React.Fragment>
        }
        else if(this.props.layout =='second'){
            let readMore = <div className="readMoreDiv"><a className="readMoreLink" href={this.props.moreLink} title={this.props.moreTitle}>{this.props.moreTitle}<i className="fa fa-arrow-left"></i></a></div>;

            events =  <React.Fragment>
                {!this.props.mobile && readMore}
                <div className="row eventLinks">
                    {this.props.items.map((item,index) => 
                        <EventLink data={item}
                        index={index} 
                        WpId={this.props.WpId} 
                        layout={this.props.layout} 
                        Title={item.Title} 
                        type={this.props.type}
                        moreTitle={this.props.moreTitle}
                        moreLink={this.props.moreLink}
                        key={"eventlink_"+index}/>
                        ) }
                </div> 
                {this.props.mobile && <div className="col-12">{readMore}</div>}
            </React.Fragment>
        }
        return (events);
    }
}
export default Event